import { render, staticRenderFns } from "./zyMuBan.vue?vue&type=template&id=2b6bc372&scoped=true"
import script from "./zyMuBan.vue?vue&type=script&lang=js"
export * from "./zyMuBan.vue?vue&type=script&lang=js"
import style0 from "./zyMuBan.vue?vue&type=style&index=0&id=2b6bc372&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6bc372",
  null
  
)

export default component.exports